export default "__VITE_ASSET__DNN4LbFl__"